import { RWebShare } from "react-web-share";
import "./WebShare.scss";
import React from 'react'

const WebShareComponent = ({ children, params }: any) => {
    
    const fullURL = window.location.href;

    
    const urlObject = new URL(fullURL);

    
    const baseURL = urlObject.origin;

    return (
        <React.Fragment>
            <RWebShare
                data={{
                    text: "Learn and Play Web Application",
                    url: baseURL + params,
                    title: "Learn and Play",
                }}
                onClick={() => console.log("shared successfully!")}
            >
                {children}
            </RWebShare>
        </React.Fragment>
    );
};

export default WebShareComponent;